const prefix = '/users';

export const ApiUsersUrls = {
  activeUser: `${prefix}/active-user`,
};
